import React, { forwardRef } from 'react';
import {
    Popover, Typography, Button, ButtonGroup, useBreakpoint
} from '@one-thd/sui-atomic-components';
import { URLS } from '../utils/constants';
import { GiftCard, Badge, Online, SpecialSavings } from '@one-thd/sui-icons';
import ProXtraLogoSvg from './ProXtraLogoSvg';
import { buildURLWithParams } from '../utils/utils';
import useQueryParams from '../utils/useQueryParams.js';

const B2bBubble = forwardRef(({ closePopover, open }, ref) => {
    const { greater: isLargeScreen } = useBreakpoint('lg');
    const [queryParams, pathName] = useQueryParams();

    const handleJoinPro = () => {
        window.sessionStorage.setItem('joinProXtra', true);
        window.location.href = buildURLWithParams(pathName, queryParams,  URLS.CREATE_ACCOUNT_BUBBLE)
        closePopover();
    };

    const handleSignIn = () => {
        window.sessionStorage.setItem('proBubbleSignIn', true);
        window.location.href = buildURLWithParams(pathName, queryParams, URLS.SIGN_IN_BUBBLE)
        closePopover();
    };

    return (
        <>
            <style>
                {/* Force darkmode styling... yeah this is pretty jank but Popovers are not currently supported by the ThemeProvider */}
                {/* @TODO: Implement this the correct way once supported */}
                {`
                    .force-black-bg *:not(button):not(.MuiButton-root):not([role="button"]),
                    .force-black-bg > *:not(button):not(.MuiButton-root):not([role="button"]),
                    .force-black-bg .MuiPaper-root {
                        background-color: rgb(55 54 54) !important;
                        background: rgb(55 54 54) !important;
                    }

                    .force-black-bg .MuiTypography-root {
                        color: white !important;
                    }

                    .force-black-bg .MuiButton-text {
                        color: white !important;
                    }

                `}
            </style>
            <Popover
                open={open}
                onClose={closePopover}
                style={{ zIndex: 1000 }}
                placement={isLargeScreen ? 'bottom-end' : 'top-end'}
                size="lg"
                className="sui-max-w-[600px] force-black-bg"
                data-testid="pro-conversion-signin-popover"
                anchorEl={ref && ref.current ? ref.current : null}
            >
                    <div>
                        <div className="sui-mb-4">
                            <Typography
                                variant="h5"
                                weight='bold'
                                color='inverse'
                            >Are You A Professional?</Typography>
                        </div>
                        <div className="title sui-mb-4">
                            <ProXtraLogoSvg/>
                            <Typography color='inverse' variant="body-base">
                                Join The Home Depot&apos;s free loyalty program Pro Xtra to manage and grow your business
                            </Typography>
                        </div>

                        <div className="benefits sui-mb-6">
                            <ul>
                                <li className="sui-flex sui-items-center sui-gap-2 sui-mb-4">
                                    <SpecialSavings color="brand" />
                                    <Typography color='inverse' variant="body-base">Volume Pricing Program</Typography>
                                </li>
                                <li className="sui-flex sui-items-center sui-gap-2 sui-mb-4">
                                    <GiftCard color="brand" />
                                    <Typography color='inverse' variant="body-base">Personalized Offers and Events</Typography>
                                </li>
                                <li className="sui-flex sui-items-center sui-gap-2 sui-mb-4">
                                    <Badge color="brand" />
                                    <Typography color='inverse' variant="body-base">Every dollar counts towards rewards</Typography>
                                </li>
                                <li className="sui-flex sui-items-center sui-gap-2 sui-mb-4">
                                    <Online color="brand" />
                                    <Typography color='inverse' variant="body-base">Receive Exclusive Offers</Typography>
                                </li>
                            </ul>
                        </div>
                        <ButtonGroup
                            orientation="vertical"
                        >
                            <Button
                                variant="primary"
                                fullWidth
                                onClick={handleJoinPro}
                                data-testid="pro-conversion-signin-join-btn"
                            >
                                Join Pro Xtra
                            </Button>
                                <Button
                                    variant="text"
                                    style={{
                                        width: '100%',
                                    }}
                                    onClick={handleSignIn}
                                >
                                    <Typography color='inverse'>
                                        Sign In To My Existing Account
                                    </Typography>
                                </Button>
                        </ButtonGroup>
                    </div>
            </Popover>
        </>
    );
});

B2bBubble.displayName = 'B2bBubble';

export default B2bBubble;